/**
 * EE 統一設定前端服務（呼叫 /api/ee/settings 與 /api/ee/mailer/test）
 */

import axios from '../api/axios';

const BASE = '/api/ee';

// ============================================================
// Types
// ============================================================

export interface MailerConfig {
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_password: string;  // 讀取時會被後端以 "***" 遮蔽
  smtp_from: string;
  smtp_use_tls: boolean;
  is_enabled: boolean;
  last_test_at: string | null;
  last_test_status: 'success' | 'failed' | null;
  last_test_message: string | null;
}

export interface SchedulerConfig {
  trigger_rest_sec: number;
  max_concurrent_repeatable: number;
  fail_alert_threshold: number;
  overdue_alert_minutes: number;
  alert_enabled: boolean;
  watchdog_interval_sec: number;
  watchdog_lookahead_sec: number;
  runs_retention_days: number;
}

export interface GoogleOAuthConfig {
  client_id: string;
  client_secret: string;   // 讀取時被後端遮蔽為 "***"
  redirect_uri: string;
  is_enabled: boolean;
  last_test_at: string | null;
  last_test_status: 'success' | 'failed' | null;
  calendar_api_key: string; // Google Calendar API Key（公開假日顯示用）
}

export interface EeSettings {
  id: number;
  config: {
    mailer?: MailerConfig;
    scheduler?: SchedulerConfig;
    google_oauth?: GoogleOAuthConfig;
    _heartbeat?: { last_at: string; host: string };
    [key: string]: any;
  };
  updated_at: string;
}

// ============================================================
// API
// ============================================================

export const getSettings = async (): Promise<EeSettings> => {
  const res = await axios.get(`${BASE}/settings`);
  return res.data;
};

export const updateMailerSettings = async (cfg: MailerConfig): Promise<void> => {
  await axios.put(`${BASE}/settings/mailer`, cfg);
};

export const updateSchedulerSettings = async (cfg: SchedulerConfig): Promise<void> => {
  await axios.put(`${BASE}/settings/scheduler`, cfg);
};

export const testMailer = async (): Promise<{ ok: boolean; message: string; tested_at: string }> => {
  const res = await axios.post(`${BASE}/mailer/test`);
  return res.data;
};

export const updateGoogleOAuthSettings = async (cfg: GoogleOAuthConfig): Promise<void> => {
  await axios.put(`${BASE}/settings/google_oauth`, cfg);
};
